import React from 'react'
import styled from 'styled-components'
import Layout from '../../components/Layout'
import Button from '../../components/Button'
import constants from '../../config/constants'

const Main = styled.div`
  padding-top: 1rem;
`

const Description = styled.p`
  font-size: 14px;
  color: ${constants.color.mediumDark};
`

const MainButton =  styled.div`
  display: flex;
  text-align: center;
`

const Consent = (props) => {
  return (
    <Layout title={'เงื่อนไขการเปิดใช้งาน'} backIcon={true} onClick={() => props.history.goBack()}>
      <Main>
        <div>
          {/* <AccessDetail> */}
            ผู้ยื่นคำขอใช้สินเชื่อส่วนบุคคลภายใต้การกำกับ (ซึ่งต่อไปนี้จะเรียกว่า "ผู้กู้") ตกลงยื่นคำขอสินเชื่อส่วนบุคคลภายใต้การกำกับ (ซึ่งต่อไปนี้จะเรียกว่า "คำขอ")
            กับบริษัท แอสเซนด์ นาโน จำกัด (ซึ่งต่อไปนี้จะเรียกว่า "ผู้ให้กู้") ผ่านระบบอิเล็กทรอนิกส์ของผู้ให้กู้ (ซึ่งต่อไปนี้จะเรียกว่า "ระบบอิเล็กทรอนิกส์")
            (ซึ่งต่อไปนี้จะเรียกคำขอใช้สินเชื่อส่วนบุคคล ภายใต้การกำกับ เอกสารแสดงข้อมูลผลิตภัณฑ์ และสัญญานี้รวมกันว่า "สัญญาสินเชื่อ")
            ซึ่งผู้กู้ตกลงจะปฏิบัติและผูกพันตามข้อตกลงและเงื่อนไขภายใต้สัญญาสินเชื่อทุกประการ
          {/* </AccessDetail> */}
          <Description style={{marginTop:'1rem', marginBottom:'2rem'}}>ข้าพเจ้าตกลง และยินยอมให้เชื่อมต่อข้อมูลของข้าพเจ้าที่มีอยู่กับทรูมูฟ เอช เข้ากับการลงทะเบียนทรูมันนี่ วอลเล็ท
            เพื่อการยืนยันตัวตนและรับสิทธิประโยชน์ต่างๆ ในการใช้งานทรูมันนี่ วอลเล็ท และการใช้บริการทรูมูฟ เอชของข้าพเจ้า</Description>
        </div>
        <MainButton>
          <Button
            textcolor={constants.color.orange}
            bordercolor={constants.color.orange}
            backgroundcolor={constants.color.white}
            text={'ยกเลิก'}
            disabled={false}
            onClick={() => props.history.push('/')}
            />
          <Button
            textcolor={constants.color.white}
            bordercolor={constants.color.orange}
            backgroundcolor={constants.color.orange}
            text={'ยืนยัน'}
            disabled={false}
            onClick={() => props.history.push('/fatca')}
            />
        </MainButton>
      </Main>
    </Layout>
  )
}

export default Consent
